import { useId } from "react";
import { cn } from "@/lib/utils";

/**
 * The AI mark: a four-point spark with a small twinkle, filled with the violet→blue AI gradient (--ai-from / --ai-to).
 * While the AI works it pulses instead of showing a spinner. Each copy has its own gradient id, so many on one screen
 * don't share (or lose) the fill.
 */
export function AiIcon({ className, busy }: { className?: string; busy?: boolean }) {
  const id = `ai-grad-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={cn("shrink-0", busy && "animate-pulse", className)}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" style={{ stopColor: "var(--ai-from)" }} />
          <stop offset="100%" style={{ stopColor: "var(--ai-to)" }} />
        </linearGradient>
      </defs>
      {/* The main spark */}
      <path fill={`url(#${id})`} d="M10.5 4.5C11.13 10.15 13.35 12.37 19 13C13.35 13.63 11.13 15.85 10.5 21.5C9.87 15.85 7.65 13.63 2 13C7.65 12.37 9.87 10.15 10.5 4.5Z" />
      {/* The twinkle */}
      <path fill={`url(#${id})`} d="M18.5 1.5C18.78 4 19.25 4.47 21.75 4.75C19.25 5.03 18.78 5.5 18.5 8C18.22 5.5 17.75 5.03 15.25 4.75C17.75 4.47 18.22 4 18.5 1.5Z" />
    </svg>
  );
}
